module.exports = __webpack_public_path__ + "assets/img/33fc62db7018b4cfa26e39723e75f6d1.png";